import { Deserializable } from '../deserializable';
import { SecurityQuestionDto } from './security-question-dto';

export class AgentDto implements Deserializable {
  public AgentID: number;
  public AgentIDHash: string;
  public Title: string;
  public FirstName: string;
  public LastName: string;
  public ContactNumber: string;
  public SecurityQuestions: Array<SecurityQuestionDto>;
  public EmailAddress: string;
  public FullName: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.SecurityQuestions = input.SecurityQuestions.map((securityQuestionDto: SecurityQuestionDto) =>
      new SecurityQuestionDto().deserialize(securityQuestionDto)
    );

    return this;
  }
}
